import React, { Component } from 'react';

class Content extends Component {
  render() {
    const { content } = this.props.block;
    return <div className='middle-navigator-content-container'>{content}</div>;
  }
}

export default Content;
